export default {
  en: {
    'components.verify-otp.resend': 'Resend code',
    'components.verify-otp.resend.message': 'Did not receive the code?',
    'components.verify-otp.change-mobile-number': 'Change mobile number',
    'components.invite-user-page.get-started': 'Get started with your {product} account',
    'components.invite-user-page.sub-heading':
      'Powerful technology automates VAT filings, specialist knowledge ensures full compliance.',
    'components.invite-user-page.sub-heading2': 'Do it all with {product} by {name}.',
    'components.invite-user-page.step.1.title': 'Create User Account',
    'components.invite-user-page.step.2.title': 'Confirm Mobile Number',
  },
};
